
import React, { useState, useEffect, useRef } from "react";
import {
  Grid, TextField, Box, Button, Typography, Paper, InputAdornment, IconButton, MenuItem, Select, FormControl,
  FormControlLabel, Radio, RadioGroup, InputLabel, Autocomplete, Tooltip, Avatar, DialogTitle, DialogContent, DialogActions,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-quill/dist/quill.snow.css";
import { useNavigate } from "react-router-dom";
import {
  getCategorydrp,
  getsubCategorydrp,
  getwardendrp,
  getBed,
  getFloor,
  getserviceProvider,
  getservicedrp,
  getAmenitydrp,
  getProperty,
  insertRiseTicket,
} from "../../../MaintenanceApp/Api/RSTicketApi";
import axiosInstance from "../../../../lib/axios";
import { z } from "zod";
import CustomAutocomplete from "../../../AutoComplete/AutoComplete";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import CloseIcon from "@mui/icons-material/Close";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import { Dialog, IconButton as MuiIconButton } from '@mui/material';
import { selectGlobalProperty } from "../../../../redux/propertySlice";
import { useSelector } from "react-redux";
import OpenInFullIcon from '@mui/icons-material/OpenInFull';

const FORM_INIT_STATE = {
  PropId: "",
  userType: "warden",
  mobileNumber: "",
  raisedBy: "",
  ticketFor: "unit",
  ticketForText: "unit",
  categoryId: "",
  subCategoryId: "",
  serviceId: "",
  description: "",
  remark: "",
  attachments: [],
  RoomBedId: "",
  floorId: "",
  amenityId: "",
  CommonAreaId: "",
  TktImage: "",   // Base64 string
  ImgName: "",    // Only filename
};

const raiseServiceTicketSchema = z
  .object({
    PropId: z.number().min(1, "Property is required"),
    categoryId: z.number().min(1, "Category is required"),
    subCategoryId: z.number().min(1, "Subcategory is required"),
    floorId: z.preprocess((val) => Number(val), z.number()).optional(),
    serviceId: z.preprocess((val) => Number(val), z.number().min(1, "Service/complaint is required")),
    CommonAreaId: z.string().optional(),
    amenityId: z.string().optional(),
    RoomBedId: z.string().optional(),
  })
  .refine((data) => {
    const { ticketFor, RoomBedId, floorId, CommonAreaId, amenityId } = data;

    if (ticketFor === "unit" && !RoomBedId) {
      return false;
    }
    if (ticketFor === "floor" && !floorId) {
      return false;
    }
    if (ticketFor === "commonArea" && !CommonAreaId) {
      return false;
    }
    if (ticketFor === "amenity" && !amenityId) {
      return false;
    }
    return true;
  });

const commonFieldSx = {
  "& .MuiFilledInput-root": {
    backgroundColor: "transparent",
    border: "1px solid #d0d0d0",
    borderRadius: 1,
    transition: "border-color 0.2s ease",

    "&:before, &:after": { display: "none" },

    "&:hover": {
      borderColor: "#a0a0a0",
    },

    "&.Mui-focused": {
      borderColor: "#635bff",
      boxShadow: "none",
    },
  },

  "& .MuiInputLabel-filled": {
    color: "inherit",
    fontWeight: "inherit",

    "&.Mui-focused": {
      color: "inherit",
    },
  },
};

const RaiseServiceTkt = () => {
  const UserId = sessionStorage.getItem("UserId");
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const [form, setForm] = useState(FORM_INIT_STATE);
  const [selectedImage, setselectedImage] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [propertyList, setPropertyList] = useState([]);
  const [floorList, setFloorList] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [subcategoryList, setSubcategoryList] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [amenityList, setAmenityList] = useState([]);
  const [isTicketForDisabled, setTicketForDisabled] = useState(false);
  const [selectedRadio, setSelectedRadio] = useState("warden");
  const [residentName, setResidentName] = useState("");
  const [residentId, setResidentId] = useState(1);
  const [isPropertyDisabled, setIsPropertyDisabled] = useState(false);
  const [isAmenityDisabled, setIsAmenityDisabled] = useState(false);
  const [commonAreaList, setCommonAreaList] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [zoomOpen, setZoomOpen] = useState(false);
  const [zoomSrc, setZoomSrc] = useState('');
  const globalProperty = useSelector(selectGlobalProperty);
  const [openService, setOpenService] = useState(false);
  const [isReverseFilling, setIsReverseFilling] = useState(false);
  const [selectedServiceInDialog, setSelectedServiceInDialog] = useState(null);

  useEffect(() => {
    if (globalProperty) {
      const propertyId = globalProperty.toString();
      const propertyExists = propertyList.find(
        (property) => property.Id.toString() === propertyId
      );

      if (propertyExists) {
        setForm((prevState) => ({
          ...prevState,
          PropId: propertyId,
        }));
      }
    }
  }, [globalProperty, propertyList]);

  useEffect(() => {
    sessionStorage.removeItem("loginType");
    const storedUserName = sessionStorage.getItem("UserName");
    const storedMobileNumber = sessionStorage.getItem("mobileNumber");
    const storedIsLoggedIn = sessionStorage.getItem("isLoggedIn");

    if (!storedUserName || storedIsLoggedIn !== "true") {
      navigate("/raise-service-tkt");
    } else {
      setForm((prevDetails) => ({
        ...prevDetails,
        raisedBy: storedUserName,
        mobileNumber: storedMobileNumber,
        userType: "warden",
      }));

      setSelectedRadio("warden");
    }
  }, [navigate]);

  useEffect(() => {
    const fetchProperties = async () => {
      const response = await getProperty({ Flag: "", UserId });
      if (response && response.data) {
        const { Status, Data } = response.data;
        if (Status === 0 && Array.isArray(Data)) {
          setPropertyList(Data);
          if (globalProperty) {
            const propertyId = globalProperty.toString();
            const propertyExists = Data.find(
              (property) => property.Id.toString() === propertyId
            );

            if (propertyExists) {
              setForm((prev) => ({
                ...prev,
                PropId: propertyId,
              }));
            } else if (Data.length > 0) {
              setForm((prev) => ({
                ...prev,
                PropId: Data[0]?.Id || "",
              }));
            }
          } else if (Data.length > 0) {
            setForm((prev) => ({
              ...prev,
              PropId: Data[0]?.Id || "",
            }));
          }
        } else {
          setPropertyList([]);
          setForm((prev) => ({
            ...prev,
            PropId: "",
          }));
        }
      }
    };
    fetchProperties();
  }, []);

  useEffect(() => {
    const fetchCommonAreas = async () => {
      const response = await axiosInstance.post(
        "MstCommonArea/GetMstCommonAreaDrp"
      );
      const {
        data: { Status, Data },
      } = response;
      if (Status === 0 && Array.isArray(Data)) {
        setCommonAreaList(Data);
        setForm((prev) => ({
          ...prev,
          CommonAreaId: Data[1]?.CommonAreaId
            ? String(Data[1]?.CommonAreaId)
            : "",
        }));
      } else {
        setCommonAreaList([]);
        setForm((prev) => ({
          ...prev,
          CommonAreaId: "",
        }));
      }
    };
    fetchCommonAreas();
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      const response = await getCategorydrp({
        PropId: form.PropId,
        flag: "Cat",
      });
      const {
        data: { Status, Data },
      } = response;
      if (Status === 0 && Array.isArray(Data)) {
        setCategoryList(Data);
        setForm((prev) => ({
          ...prev,
          categoryId: Data[0]?.Id || "",
        }));
      } else {
        setCategoryList([]);
        if (!isReverseFilling) {
          setForm(prev => ({ ...prev, subCategoryId: "", serviceId: "" }));
          setServiceList([]);
        }
      }
    };

    if (form.PropId) {
      fetchCategories();
    }
  }, [form.PropId]);

  useEffect(() => {
    const fetchSubcategories = async () => {
      if (!form.categoryId) {
        setSubcategoryList([]);
        setServiceList([]);
        setForm(prev => ({ ...prev, subCategoryId: "", serviceId: "" }));
        return;
      }
      try {
        const response = await getsubCategorydrp({ flag: "", TktCategoryId: form.categoryId });
        const { Status, Data } = response.data;
        if (Status === 0 && Array.isArray(Data)) {
          setSubcategoryList(Data);
          if (!isReverseFilling) {          // ← GUARD
            setForm(prev => ({ ...prev, subCategoryId: "", serviceId: "" }));
            setServiceList([]);
          }
        } else {
          setSubcategoryList([]);
          if (!isReverseFilling) {          // ← GUARD
            setServiceList([]);
            setForm(prev => ({ ...prev, subCategoryId: "", serviceId: "" }));
          }
        }
      } catch (err) {
        setSubcategoryList([]);
        if (!isReverseFilling) {            // ← GUARD
          setServiceList([]);
          setForm(prev => ({ ...prev, subCategoryId: "", serviceId: "" }));
        }
      }
    };
    fetchSubcategories();
  }, [form.categoryId]);

  useEffect(() => {
    const fetchServices = async () => {
      if (form.subCategoryId) {
        const response = await getservicedrp({ TktSubCategoryId: form.subCategoryId, Flag: "Tk" });
        const { data: { Status, Data } } = response;
        if (Status === 0 && Array.isArray(Data)) {
          setServiceList(Data);
          if (!isReverseFilling) {          // ← GUARD
            setForm(prev => ({ ...prev, serviceId: "" }));
          }
        } else {
          setServiceList([]);
          if (!isReverseFilling) {          // ← GUARD
            setForm(prev => ({ ...prev, serviceId: "" }));
          }
        }
      }
    };
    fetchServices();
  }, [form.subCategoryId]);

  const fetchAllServices = async () => {
    try {
      const response = await axiosInstance.post('Ticket/getTicketdrp', {
        TktSubCategoryId: 1,
        Flag: ""
      });

      const { Status, Data } = response.data;
      if (Status === 0 && Array.isArray(Data)) {
        setServiceList(Data);
      } else {
        setServiceList([]);
      }
    } catch (error) {
      toast.error("Failed to load all services");
    }
  };

  useEffect(() => {
    const fetchAmenities = async () => {
      if (form.ticketFor === "amenity") {
        const response = await getAmenitydrp({
          PropId: form.PropId,
          flag: "Am",
        });
        if (response && response.data) {
          const { Status, Data } = response.data;
          if (Status === 0 && Array.isArray(Data)) {
            setAmenityList(Data);
            setForm((prev) => ({
              ...prev,
              amenityId: String(Data[0]?.Id || ""),
            }));
          } else {
            setAmenityList([]);
            setForm((prev) => ({
              ...prev,
              amenityId: "",
            }));
          }
        }
      }
    };
    fetchAmenities();
  }, [form.ticketFor, form.PropId]);

  useEffect(() => {
    const fetchBeds = async () => {
      if (form.ticketFor === "unit" && form.PropId) {
        const response = await getBed({ PropId: form.PropId, flag: "Bd" });
        const {
          data: { Status, Data },
        } = response;
        if (Status === 0 && Array.isArray(Data)) {
          setUnitList(Data);
          setForm((prev) => ({
            ...prev,
            RoomBedId: String(Data[1]?.Id || ""),
          }));
        } else {
          setUnitList([]);
          setForm((prev) => ({
            ...prev,
            RoomBedId: "",
          }));
        }
      }
    };
    fetchBeds();
  }, [form.ticketFor, form.PropId]);

  useEffect(() => {
    const fetchFloors = async () => {
      if (form.PropId) {
        const floorResponse = await getFloor({
          PropId: form.PropId,
          Flag: "Fl",
        });
        const {
          data: { Status: floorStatus, Data: floorData },
        } = floorResponse;
        if (floorStatus === 0 && Array.isArray(floorData)) {
          setFloorList(floorData);
          setForm((prev) => ({
            ...prev,
            floorId: String(floorData[0]?.Id || ""),
          }));
        } else {
          setFloorList([]);
        }
      }
    };
    fetchFloors();
  }, [form.PropId]);

  const handleChange = async (e) => {
    const { name, value } = e.target;

    if (name === "PropId") {
      setForm((prev) => ({
        ...prev,
        PropId: value,
      }));
    } else if (name === "categoryId") {
      setForm((prev) => ({
        ...prev,
        categoryId: value,
        subCategoryId: "",
        serviceId: "",
      }));
    } else if (name === "subCategoryId") {
      setForm((prev) => ({
        ...prev,
        subCategoryId: value,
        serviceId: "",
      }));
    } else if (name === "serviceId") {
      setForm((prev) => ({
        ...prev,
        serviceId: String(value),
      }));
    } else if (name === "CommonAreaId") {
      setForm((prev) => ({
        ...prev,
        CommonAreaId: String(value),
      }));
    } else if (name === "amenityId") {
      setForm((prev) => ({
        ...prev,
        amenityId: String(value),
      }));
    } else if (name === "RoomBedId") {
      setForm((prev) => ({
        ...prev,
        RoomBedId: String(value),
      }));
    } else {
      setForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleOpenServiceDialog = async () => {
    await fetchAllServices();   // Fetch fresh list when dialog opens
    setOpenService(true);
  };

  const handleCloseServiceDialog = () => {
    setOpenService(false);
  };

  const handleFindService = () => {
    if (!selectedServiceInDialog) {
      toast.warning("Please select a service first");
      return;
    }

    const catId = selectedServiceInDialog.TktCategoryId ||
      selectedServiceInDialog.CategoryId ||
      selectedServiceInDialog.CategoryID;

    const subCatId = selectedServiceInDialog.TktSubCategoryId ||
      selectedServiceInDialog.SubCategoryId ||
      selectedServiceInDialog.SubCategoryID;

    setIsReverseFilling(true);   // ← SET BEFORE form update

    setForm(prev => ({
      ...prev,
      serviceId: String(selectedServiceInDialog.Id),
      categoryId: catId ? String(catId) : prev.categoryId,
      subCategoryId: subCatId ? String(subCatId) : prev.subCategoryId,
    }));

    setSelectedServiceInDialog(null);
    setOpenService(false);

    setTimeout(() => setIsReverseFilling(false), 800);  // ← RESET after effects settle
  };

  const handleBodyChange = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });
  };

  const handleDrop = (acceptedFiles) => {
    setForm((prevDetails) => ({
      ...prevDetails,
      attachments: [...prevDetails.attachments, ...acceptedFiles],
    }));
  };

  const removeAttachment = (index) => {
    setForm((prevDetails) => ({
      ...prevDetails,
      attachments: prevDetails.attachments.filter((_, i) => i !== index),
    }));
  };

  const handleTicketForChange = (e) => {
    const selectedTicket = e.target.value;
    if (selectedRadio === "resident" && selectedTicket !== "unit") {
      toast.error("Residents can only raise tickets for units.");
      return;
    }
    setForm((prev) => ({
      ...prev,
      ticketFor: selectedTicket,
      ticketForText: selectedTicket,
      RoomBedId: selectedTicket === "unit" ? prev.RoomBedId : "",
      floorId: selectedTicket === "floor" ? prev.floorId : "",
      amenityId: selectedTicket === "amenity" ? prev.amenityId : "",
      CommonAreaId:
        selectedTicket === "commonArea" ? prev.CommonAreaId : "",
    }));
  };

  const fetchServiceProvider = async () => {
    try {
      const response = await axiosInstance.post(
        "/TrnTicketing/getPropWiseCatWrSprodrp",
        {
          PropId: form.PropId,
          TktCategoryId: form.categoryId,
          flag: "SP",
        }
      );

      const { Status, Data } = response.data;
      if (Status === 0 && Array.isArray(Data) && Data.length > 0) {
        return Data[0].Id;
      }
    } catch (error) {
      console.error("Error fetching service provider:", error);
      return null;
    }
  };

  const fetchWardenData = async () => {
    try {
      const response = await axiosInstance.post(
        "/TrnTicketing/getPropWiseCatWrSprodrp",
        {
          PropId: form.PropId,
          TktCategoryId: form.categoryId,
          flag: "Wr",
        }
      );

      const { Status, Data } = response.data;
      if (Status === 0 && Array.isArray(Data) && Data.length > 0) {
        return Data[0].Id;
      } else {
        return 1;
      }
    } catch (error) {
      console.error("Error fetching Warden data:", error);
      return 1;
    }
  };

  // UPDATED: Handle image → Base64 + filename only
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif"];
    if (!validTypes.includes(file.type)) {
      toast.error("Please upload a valid image (JPEG, PNG, GIF)");
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result;
      const fileName = file.name;

      setForm((prev) => ({
        ...prev,
        TktImage: base64String,
        ImgName: fileName,
      }));
      setselectedImage(base64String); // For preview
    };
    reader.onerror = () => {
      toast.error("Failed to read file.");
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    // Convert necessary fields to proper types before validation
    const updatedForm = {
      ...form,
      PropId: parseInt(form.PropId),
      RoomBedId: String(form.RoomBedId),
      floorId: form.floorId ? parseInt(form.floorId) : 1,
      amenityId: form.amenityId ? String(form.amenityId) : "",
      CommonAreaId: form.CommonAreaId ? String(form.CommonAreaId) : "",
      categoryId: parseInt(form.categoryId),
      subCategoryId: parseInt(form.subCategoryId),
      serviceId: form.serviceId ? String(form.serviceId) : "",
    };

    // Validate the updated form
    const result = raiseServiceTicketSchema.safeParse(updatedForm);
    if (!result.success) {
      console.log("Validation Errors:", result.error.format());
      return toast.info("Please fill in all required inputs correctly", {
        autoClose: 1000,
      });
    }

    if (!updatedForm.PropId || !updatedForm.categoryId) {
      return;
    }

    const ServiceProviderId = (await fetchServiceProvider()) || 1;
    const WardenId = (await fetchWardenData()) || 1;

    // Prepare payload
    const payload = {
      UserId: UserId,
      PropId: updatedForm.PropId,
      ResidentId: residentId,
      MobileNo: updatedForm.mobileNumber,
      Name: updatedForm.raisedBy,
      TktFor:
        updatedForm.ticketFor === "unit"
          ? "U"
          : updatedForm.ticketFor === "floor"
            ? "F"
            : updatedForm.ticketFor === "commonArea"
              ? "C"
              : "A",
      BedId: updatedForm.ticketFor === "unit" ? String(updatedForm.RoomBedId) : "1",
      FloorId: updatedForm.ticketFor === "floor" ? String(updatedForm.floorId) : "1",
      AmenityId: updatedForm.ticketFor === "amenity" ? String(updatedForm.amenityId) : "1",
      CommonAreaId: updatedForm.ticketFor === "commonArea" ? String(updatedForm.CommonAreaId) : "1",
      TktCategoryId: updatedForm.categoryId,
      TktSubCategoryId: updatedForm.subCategoryId,
      TicketTypeId: 1,
      TicketTagId: 1,
      TicketSeverityId: 1,
      WardenId: WardenId,
      TktServiceId: updatedForm.serviceId,
      ServiceProvId: ServiceProviderId,
      EscalateId: 1,
      ForwardedId: 1,
      TktImage: updatedForm.TktImage,  // Base64
      ImgName: updatedForm.ImgName,    // Only filename
      TicketSt: "O",
      ReqFlg: "R",
      Reason: "",
      AcceptFlg: "N",
      AssignFlg: "N",
      Description: updatedForm.description,
      Remark: updatedForm.remark,
      status: "1",
      CreatedBy: UserId,
    };

    // Disable button and show loading
    setIsSubmitting(true);

    try {
      const response = await insertRiseTicket(payload);

      const { data: { Status, Message, Data } } = response;

      if (Status === 0 && Message && Data) {
        // toast.success(Message, { autoClose: 500 });
        const ticketId = Data;
        toast.success(
          <>
            <strong>{Message}</strong>
            <br />
            <Box sx={{ mt: 1, fontSize: '1.1em', fontWeight: 'bold' }}>
              Ticket Id:
              <span style={{ color: '#c8f7c8', marginLeft: 1 }}>
                {ticketId}
              </span>
            </Box>
          </>,
          {
            autoClose: 2000,
            style: { background: '#5ccc5cff', color: '#fff' }
          }
        );
        setTimeout(() => {
          navigate("/raise-service-tkt-table");
        }, 3000);
      } else {
        toast.error(Message, { autoClose: 1000 });
      }
    } catch (error) {
      toast.error("An error occurred while submitting the ticket.");
    }
  };

  const handleCancel = () => {
    // navigate("/service&ticket/complaint");
    navigate("/ticket");
  };

  return (
    <>
      <ToastContainer />
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        style={{
          maxHeight: "100vh",
          backgroundColor: "#f5f5f5",
          paddingTop: "5px",
        }}
      >
        <Grid item xs={12} md={10} lg={10}>
          <Paper
            elevation={3}
            style={{
              paddingInline: "16px",
              paddingBlock: "6px",
              borderRadius: "10px",
              marginBlock: "20px 30px",
              marginInline: "10px",
              marginInline: "auto",
              width: 900,
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              mb={2}
            >
              <Tooltip
                title="Go Back"
                arrow
                onClick={() => navigate("/service&ticket/complaint")}
              >
                <IconButton>
                  <KeyboardBackspaceIcon
                    sx={{
                      fontSize: { xs: 20, sm: 24, md: 28 },
                      color: "#635bff",
                    }}
                  />
                </IconButton>
              </Tooltip>
              <Typography variant="h6" gutterBottom sx={{ ml: 1 }}>
                Raise Service Ticket
              </Typography>
            </Box>

            <form onSubmit={handleSubmit}>
              {/* User Type Radio Buttons */}
              <Box mb={2}>
                <RadioGroup
                  row
                  name="userType"
                  value={form.userType}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="warden"
                    control={<Radio />}
                    label="Warden"
                  />
                  <FormControlLabel
                    value="resident"
                    control={<Radio />}
                    label="Resident"
                  />
                  <FormControlLabel
                    value="auto"
                    control={<Radio />}
                    label="Auto"
                  />
                </RadioGroup>
              </Box>

              {/* Property Dropdown */}
              <Grid item xs={12} md={12} className="form_field" sx={{ mb: 2 }}>
                <CustomAutocomplete
                  options={propertyList}
                  id="PropId-autocomplete"
                  name="PropId"
                  label="Property"
                  className="custom-textfield"
                  variant='filled'
                  value={
                    propertyList.find(
                      (property) => property.Id.toString() === form.PropId
                    ) || null
                  }
                  onChange={handleChange}
                />
              </Grid>

              {/* Mobile Number and Raised By */}
              <Grid container spacing={2} mb={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    className="custom-textfield"
                    variant="filled"
                    label={
                      <span>
                        Mobile Number<span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="mobileNumber"
                    value={form.mobileNumber}
                    onChange={handleChange}
                    disabled={form.userType === "warden"}
                    inputProps={{ maxLength: 10 }}
                    sx={commonFieldSx}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    className="custom-textfield"
                    variant="filled"
                    label={
                      <span>
                        Raised By<span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="raisedBy"
                    value={form.raisedBy}
                    disabled={form.userType !== "auto"}
                    sx={commonFieldSx}
                  />
                </Grid>
              </Grid>

              <Box mb={2} />

              {/* Ticket For */}
              <Grid container spacing={2} sx={{ mb: 2 }}>
                <Grid item xs={12}>
                  <Typography variant="h6">Ticket For</Typography>
                </Grid>
                <Grid item xs={12}>
                  <RadioGroup
                    row
                    name="ticketFor"
                    value={form.ticketFor}
                    onChange={handleTicketForChange}
                  >
                    <FormControlLabel
                      value="unit"
                      control={<Radio />}
                      label="Unit"
                    />
                    <FormControlLabel
                      value="floor"
                      control={<Radio />}
                      label="Floor"
                    />
                    <FormControlLabel
                      value="commonArea"
                      control={<Radio />}
                      label="Common Area"
                    />
                    <FormControlLabel
                      value="amenity"
                      control={<Radio disabled={isAmenityDisabled} />}
                      label="Amenity"
                    />
                  </RadioGroup>
                </Grid>
              </Grid>

              {/* Unit, Property, Amenity Dropdowns */}
              <Grid container spacing={2} sx={{ mb: 2 }}>
                {form.ticketFor === "unit" && (
                  <Grid item xs={12} sm={6} md={6}>
                    <CustomAutocomplete
                      options={unitList}
                      id="RoomBedId-autocomplete"
                      name="RoomBedId"
                      label={
                        <span>
                          Select Bed<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      value={unitList.find((u) => u.Id == form.RoomBedId) || null}
                      onChange={handleChange}
                      className="custom-textfield"
                      variant='filled'
                    />
                  </Grid>
                )}

                {form.ticketFor === "floor" && (
                  <Grid item xs={12} sm={6} md={6}>
                    <CustomAutocomplete
                      options={floorList}
                      id="floorId-autocomplete"
                      name="floorId"
                      label={
                        <span>
                          Select Floor<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      value={
                        floorList.find((f) => f.Id == form.floorId) || null
                      }
                      onChange={handleChange}
                      className="custom-textfield"
                      variant='filled'
                    />
                  </Grid>
                )}

                {form.ticketFor === "commonArea" && (
                  <Grid item xs={12} sm={6} md={6}>
                    <CustomAutocomplete
                      options={commonAreaList}
                      id="CommonAreaId-autocomplete"
                      name="CommonAreaId"
                      label={
                        <span>
                          Select Common Area<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      value={
                        commonAreaList.find(
                          (a) => a.CommonAreaId == form.CommonAreaId
                        ) || null
                      }
                      onChange={handleChange}
                      className="custom-textfield"
                      variant='filled'
                    />
                  </Grid>
                )}

                {form.ticketFor === "amenity" && (
                  <Grid item xs={12} sm={6} md={6}>
                    <CustomAutocomplete
                      options={amenityList}
                      id="amenityId-autocomplete"
                      name="amenityId"
                      label={
                        <span>
                          Select Amenity<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      value={
                        amenityList.find(
                          (amenity) => amenity.Id == form.amenityId
                        ) || null
                      }
                      onChange={handleChange}
                      className="custom-textfield"
                      variant='filled'
                    />
                  </Grid>
                )}

                {/* Remark field */}
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    fullWidth
                    variant="filled"
                    className="custom-textfield"
                    label="Remark"
                    name="remark"
                    value={form.remark || ""}
                    onChange={(e) => handleBodyChange("remark", e.target.value)}
                    sx={commonFieldSx}
                  />
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12} md={12} className="form_field" sx={{ mb: 2 }}>
                <CustomAutocomplete
                  options={categoryList}
                  id="category-select"
                  name="categoryId"
                  label={
                    <span>
                      Category<span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  value={
                    categoryList.find(
                      (category) => category.Id == form.categoryId
                    ) || null
                  }
                  onChange={handleChange}
                  fullWidth
                  className="custom-textfield"
                  variant='filled'
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} className="form_field" sx={{ mb: 2 }}>
                <CustomAutocomplete
                  key={form.categoryId}
                  id="subcategory-select"
                  name="subCategoryId"
                  label={
                    <span>
                      Subcategory<span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  options={subcategoryList}
                  value={
                    subcategoryList.find(
                      (subcategory) => subcategory.Id == form.subCategoryId
                    ) || null
                  }
                  onChange={handleChange}
                  className="custom-textfield"
                  variant='filled'
                />
              </Grid>

              <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
                <Grid item xs={10} sm={10} md={10}>
                  <CustomAutocomplete
                    key={form.subCategoryId}
                    id="service-select"
                    name="serviceId"
                    label={
                      <span>
                        Service/complaint<span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    options={serviceList}
                    value={
                      serviceList.find(
                        (service) => service.Id == form.serviceId
                      ) || null
                    }
                    onChange={handleChange}
                    className="custom-textfield"
                    variant='filled'
                  />
                </Grid>

                <Grid item xs={2} sm={2} md={2} >
                  <Tooltip title="Load ALL Services" arrow>
                    <Button variant="outlined" size="small" onClick={handleOpenServiceDialog} startIcon={<OpenInFullIcon />}>
                      Service
                    </Button>
                  </Tooltip>
                </Grid>
              </Grid>

              {/* Upload Image */}
              <Grid container spacing={1} sx={{ mb: 2 }}>
                <Grid item xs={12} sm={2} md={1.5}
                  sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-start' } }}
                >
                  <Box
                    sx={{
                      position: 'relative',
                      width: 100,
                      height: 100,
                      borderRadius: 2,
                      border: form.TktImage ? '2px solid #635bff' : '2px dashed #635bff',
                      bgcolor: '#fafafa',
                      overflow: 'hidden',
                      cursor: 'pointer',
                      transition: 'all .2s',
                      '&:hover': { borderColor: '#ccc' },
                    }}
                  >
                    {/* ----- IMAGE OR PLACEHOLDER ----- */}
                    {form.TktImage ? (
                      <img
                        src={form.TktImage}
                        alt="Preview"
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        onClick={() => {
                          setZoomSrc(form.TktImage);
                          setZoomOpen(true);
                        }}
                      />
                    ) : (
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        sx={{
                          textAlign: 'center',
                          px: 1,
                          fontSize: '0.8rem',
                          lineHeight: 1.3,
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%,-50%)',
                        }}
                      >
                        Click to Upload Image
                      </Typography>
                    )}

                    <input
                      ref={fileInputRef}
                      type="file"
                      accept="image/*"
                      onChange={handleFileChange}
                      style={{
                        position: 'absolute',
                        inset: 0,
                        opacity: 0,
                        cursor: 'pointer',
                      }}
                    />

                    {/* ----- DELETE ICON (only when image exists) ----- */}
                    {form.TktImage && (
                      <Tooltip title="Remove Image" arrow>
                        <MuiIconButton
                          size="small"
                          color="error"
                          onClick={(e) => {
                            e.stopPropagation();
                            setForm((p) => ({ ...p, TktImage: '', ImgName: '' }));
                            setselectedImage('');
                            if (fileInputRef.current) {
                              fileInputRef.current.value = '';
                            }
                          }}
                          sx={{
                            position: 'absolute',
                            top: -4,
                            right: -4,
                            bgcolor: 'background.paper',
                            boxShadow: 2,
                            '&:hover': { bgcolor: 'error.light', color: '#fff' },
                          }}
                        >
                          <DeleteForeverIcon fontSize="small" />
                        </MuiIconButton>
                      </Tooltip>
                    )}

                    {/* ----- ZOOM ICON (only when image exists) ----- */}
                    {form.TktImage && (
                      <Tooltip title="Zoom Image" arrow>
                        <MuiIconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            setZoomSrc(form.TktImage);
                            setZoomOpen(true);
                          }}
                          sx={{
                            position: 'absolute',
                            bottom: 1,
                            right: -1,
                            bgcolor: 'rgba(0,0,0,0.7)',
                            color: '#fff',
                            '&:hover': { bgcolor: 'primary.main' },
                          }}
                        >
                          <ZoomInIcon fontSize="small" />
                        </MuiIconButton>
                      </Tooltip>
                    )}
                  </Box>
                </Grid>

                {/* Description */}
                <Grid item xs={12} sm={10} md={10.5}>
                  <Box>
                    <TextField
                      fullWidth
                      className="custom-textfield"
                      variant="filled"
                      name="description"
                      label="Description"
                      value={form.description || ""}
                      onChange={(e) =>
                        handleBodyChange("description", e.target.value)
                      }
                      multiline
                      rows={2}
                      sx={commonFieldSx}
                    />
                  </Box>
                </Grid>

              </Grid>

              {/* Submit and Cancel Buttons */}
              <Box
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
                paddingTop="10px"
              >
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting}
                  sx={{
                    backgroundColor: isSubmitting ? "#ccc" : "#635bff",
                    "&:hover": {
                      backgroundColor: isSubmitting ? "#ccc" : "#dddbff",
                    },
                    padding: "8px 16px",
                    fontSize: "14px",
                    minWidth: "100px",
                  }}
                >
                  {/* Submit */}
                  {isSubmitting ? "Submitting..." : "Submit"}
                </Button>

                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleCancel}
                  sx={{
                    borderColor: "#635bff",
                    color: "#635bff",
                    "&:hover": {
                      borderColor: "#dddbff",
                      color: "#635bff",
                    },
                    padding: "8px 16px",
                    marginLeft: "10px",
                    fontSize: "14px",
                  }}
                >
                  Cancel
                </Button>
              </Box>
            </form>

            {/* ────────────────────── ZOOM DIALOG ────────────────────── */}
            <Dialog
              open={zoomOpen}
              onClose={() => setZoomOpen(false)}
              maxWidth="md"
              fullWidth
              BackdropProps={{ sx: { bgcolor: 'rgba(0,0,0,0.95)' } }}
              PaperProps={{
                sx: { bgcolor: 'transparent', boxShadow: 'none', overflow: 'hidden', m: 2 },
              }}
            >
              <MuiIconButton
                onClick={() => setZoomOpen(false)}
                sx={{
                  position: 'absolute',
                  top: 8,
                  right: 8,
                  bgcolor: 'rgba(255,255,255,0.9)',
                  color: 'black',
                  '&:hover': { bgcolor: '#fff' },
                  zIndex: 10,
                  boxShadow: 3,
                }}
              >
                <CloseIcon />
              </MuiIconButton>

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '90vh',
                  cursor: 'zoom-out',
                }}
                onClick={() => setZoomOpen(false)}
              >
                <Box
                  component="img"
                  src={zoomSrc}
                  alt="Zoomed"
                  sx={{
                    maxWidth: '90%',
                    maxHeight: '90%',
                    objectFit: 'contain',
                    borderRadius: 2,
                    boxShadow: 10,
                    userSelect: 'none',
                  }}
                />
              </Box>
            </Dialog>

            <Dialog open={openService} onClose={handleCloseServiceDialog} maxWidth="sm" fullWidth>
              <DialogTitle sx={{ px: 2, py: 1 }}>
                Select Service / Complaint
                <IconButton onClick={handleCloseServiceDialog} sx={{ position: 'absolute', right: 8, top: 8 }}>
                  <CloseIcon color="error" />
                </IconButton>
              </DialogTitle>

              <DialogContent>
                <Box sx={{ mt: 2 }}>
                  <CustomAutocomplete
                    id="dialog-service-select"
                    name="serviceId"
                    label="Service/Complaint"
                    className="custom-textfield"
                    variant='filled'
                    fullWidth
                    options={serviceList}
                    value={
                      selectedServiceInDialog ||
                      serviceList.find(s => String(s.Id) === String(form.serviceId)) ||
                      null
                    }
                    onChange={(e) => {
                      const selected = serviceList.find(
                        (s) => String(s.Id) === String(e.target.value)
                      );
                      setSelectedServiceInDialog(selected || null);
                    }}
                  />
                </Box>
              </DialogContent>

              <DialogActions>
                <Button variant='contained' size="small" onClick={handleFindService} color="success">Find</Button>
              </DialogActions>
            </Dialog>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};

export default RaiseServiceTkt;